<div>
  <div class="flex flex-col gap-3">
    <div *ngIf="showAdvanceSearch">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advanced Search'">
          <!--          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">-->
          <!--            <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">-->
          <!--          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">-->

          <!--            <div class="flex flex-col lg:flex-row lg:items-center">-->

          <!--              <nz-form-item class="m-0">-->
          <!--                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">-->
          <!--                  <input type="text" [(ngModel)]="searchText" nz-input placeholder="Search Users"/>-->
          <!--                </nz-input-group>-->
          <!--                <ng-template #suffixIconSearchButton>-->
          <!--                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">-->
          <!--                    <span nz-icon nzType="search"></span>-->
          <!--                  </button>-->
          <!--                </ng-template>-->
          <!--              </nz-form-item>-->

          <!--              <div class="flex flex-col lg:flex-row lg:items-center lg:order-first 2xl:order-last">-->
          <!--                <nz-divider class="hidden 2xl:block" [nzType]="'vertical'"></nz-divider>-->

          <!--                <nz-form-item class="flex flex-col xl:flex-row m-0">-->
          <!--                  <nz-form-label class="text-start">Filter by Status</nz-form-label>-->
          <!--                  <nz-select [(ngModel)]="filterStatus" (ngModelChange)="search()" nzPlaceHolder="Select Status"-->
          <!--                             [nzAllowClear]="true">-->
          <!--                    <nz-option [nzValue]="true" nzLabel="Active"></nz-option>-->
          <!--                    <nz-option [nzValue]="false" nzLabel="Inactive"></nz-option>-->
          <!--                  </nz-select>-->
          <!--                </nz-form-item>-->

          <!--                <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->

          <!--                <nz-form-item class="flex flex-col xl:flex-row m-0">-->
          <!--                  <nz-form-label class="text-start">Filter by Role</nz-form-label>-->
          <!--                  <nz-select [(ngModel)]="filterRole" (ngModelChange)="search()" nzPlaceHolder="Select Role"-->
          <!--                             [nzAllowClear]="true">-->
          <!--                    <nz-option *ngFor="let op of rolesOptions" [nzValue]="op._id"-->
          <!--                               nzLabel="{{ op.name | titlecase }}"></nz-option>-->
          <!--                  </nz-select>-->
          <!--                </nz-form-item>-->

          <!--                <nz-divider class="hidden lg:block 2xl:hidden" [nzType]="'vertical'"></nz-divider>-->
          <!--              </div>-->

          <!--            </div>-->

          <!--            <div>-->
          <!--              <button nz-button nzBlock class="outline-button" (click)="resetSearch()">-->
          <!--                Reset Search-->
          <!--              </button>-->
          <!--            </div>-->

          <!--          </div>-->
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div class="table-card">
      <div class="table-obj">
        <nz-table #basicTable
                  [nzData]="dummyData"
                  [nzShowSizeChanger]="true"
                  [nzPageSize]="10"
                  [nzPageIndex]="0" [nzFrontPagination]="false" [nzShowPagination]="false" [nzTotal]="10"
                  nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }">
          <thead>
          <tr>
            <th style="white-space: nowrap;" *ngFor="let coulmn of columnData">{{coulmn}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td style="white-space: nowrap;" *ngFor="let column of columnData">
              <nz-skeleton class="" [nzTitle]="false" [nzActive]="true" [nzParagraph]="{ rows: 1 }"></nz-skeleton>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
</div>
